import React from 'react';
import { Icon } from '../icon/Icon';
import { mcPlay } from '@mc/react-ui-icons';
import * as Classes from '../common/classes';

type VideoThumbnailProps = {};

export function VideoThumbnail({}: VideoThumbnailProps) {
  return (
    <div className={Classes.VIDEO_THUMB}>
      <Icon icon={mcPlay} size={'2x'} />
    </div>
  );
}
